<template>
  <el-container class="mainer">
    <el-aside width="240px">
      <!-- 华南医院特殊logo -->
      <div v-if="code == 339" style="text-align: center;margin: 10px 0;"><el-image src="https://oss.huarendjk.com/files/nfksVSG2hQptUTPNEi8gzRtvXqPRJ5SfHhXf5WEl.png" style="width: 200px;" alt=""></el-image></div>
      <h1 v-else class="brand">{{ user_type === 'agent' ? '代理云平台' : '康家云平台' }}</h1>
      <div class="user" v-if="user_type == 'agent'">
        <el-avatar :size="36" src="https://oss.huarendjk.com/img/2021-12-30/61cd8c3458ffc.png"> </el-avatar>
        <div class="usertitle">
          <p>{{ company }}</p>
          <p>
            代理等级：
            <span>
              {{ type == 1 ? 'VIP' : type == 2 ? '铂金' : type == 3 ? '钻石' : '' }}
            </span>
          </p>
        </div>
      </div>
      <div class="user" v-else>
        <el-avatar :size="36" src="https://oss.huarendjk.com/img/2021-12-30/61cd8c3458ffc.png"> </el-avatar>
        <div class="usertitle">
          <p>{{ title }}</p>
          <p>
            康家代码：
            <span>
              {{ code }}
            </span>
          </p>
        </div>
      </div>
      <el-menu router :default-active="activeIndex" background-color="#2F3E62" text-color="#ddd" active-text-color="#ffd04b">
        <div v-for="item in menus" :key="item.id" class="menu">
          <el-submenu v-if="item.children" :index="item.url">
            <template slot="title"><i :class="item.icon"></i> {{ item.title }}</template>
            <el-menu-item-group>
              <div v-for="subItem in item.children" :key="subItem.id">
                <el-submenu v-if="subItem.children" :index="subItem.url">
                  <template slot="title"><i :class="subItem.icon"></i> {{ subItem.title }}</template>
                  <el-menu-item-group>
                    <div v-for="thrItem in subItem.children" :key="thrItem.id">
                      <el-submenu v-if="thrItem.children" :index="thrItem.url">
                        <template slot="title"><i :class="thrItem.icon"></i> {{ thrItem.title }}</template>
                        <el-menu-item-group>
                          <el-menu-item v-for="fthItem in thrItem.children" :key="fthItem.id" :index="fthItem.url"
                            ><i :class="fthItem.icon"></i>
                            {{ fthItem.title }}
                          </el-menu-item>
                        </el-menu-item-group>
                      </el-submenu>
                      <el-menu-item else :index="thrItem.url"
                        ><i :class="thrItem.icon"></i>
                        {{ thrItem.title }}
                      </el-menu-item>
                    </div>
                  </el-menu-item-group>
                </el-submenu>
                <el-menu-item :index="subItem.url" v-else
                  ><i :class="subItem.icon"></i>
                  {{ subItem.title }}
                </el-menu-item>
              </div>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item v-else :index="item.url"><i :class="item.icon"></i> {{ item.title }}</el-menu-item>
        </div>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header height="120">
        <div v-if="user_type == 'agent'">
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="18">
              <el-menu
                background-color="#2F3E62"
                text-color="#ddd"
                active-text-color="#ffd04b"
                class="el-menu-notify"
                mode="horizontal"
              >
                <el-menu-item index="1">代理云平台</el-menu-item>
                <el-menu-item index="2">申请康家云平台</el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="6">
              <el-menu
                background-color="#2F3E62"
                text-color="#ddd"
                active-text-color="#ffd04b"
                class="el-menu-notify"
                mode="horizontal"
              >
                <el-menu-item index="1" @click="logout"><i class="el-icon-switch-button"></i> </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="18">
              <el-menu
                background-color="#2F3E62"
                text-color="#ddd"
                active-text-color="#ffd04b"
                class="el-menu-notify"
                mode="horizontal"
              >
                <el-menu-item index="1">康家云平台</el-menu-item>
                <el-menu-item index="2">申请代理云平台</el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="6">
              <el-menu
                background-color="#2F3E62"
                text-color="#ddd"
                active-text-color="#ffd04b"
                class="el-menu-notify"
                mode="horizontal"
              >
                <el-menu-item index="1" @click="logout"><i class="el-icon-switch-button"></i> </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </div>
        <div class="page-tabs">
          <el-tabs
            v-model="activeIndex"
            type="card"
            closable
            @tab-click="tabClick"
            v-if="pageTabs.length"
            @tab-remove="tabRemove"
          >
            <el-tab-pane :key="item.route" v-for="item in pageTabs" :label="item.meta.title" :name="item.route"> </el-tab-pane>
          </el-tabs>
        </div>
      </el-header>
      <el-main>
        <transition name="fade" mode="out-in">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
              <!-- 这里是会被缓存的视图组件 -->
            </router-view>
          </keep-alive>
        </transition>
        <transition name="fade" mode="out-in">
          <router-view v-if="!$route.meta.keepAlive">
            <!-- 这里是不被缓存的视图组件 -->
          </router-view>
        </transition>
      </el-main>
      <el-footer>
        <div class="copy-content">Copyright &copy; 华仁大健康管理咨询有限公司</div>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { kang_jia, agent } from './menu.js'

export default {
  data() {
    return {
      editorOption: {
        placeholder: '请输入回复内容',
        theme: 'bubble',
      },
      moduleIndex: '0',
      adminer: '',
      kefuDialogVisible: false,
      customers: [],
      reply: '',
      user_type: '',
      code: '',
      username: '',
      title: '',
      customerPage: 0,
      kefuSearchKeyword: '',
      type: '',
      company: '',
    }
  },
  mounted() {
    this.adminer = window.sessionStorage.getItem('adminer')
    this.user_type = window.sessionStorage.getItem('user_type')
    this.type = window.sessionStorage.getItem('type')
    this.company = window.sessionStorage.getItem('company')
    this.code = window.sessionStorage.getItem('userId')
    this.title = window.sessionStorage.getItem('title')

    let menus = []
    if (this.user_type == 'agent') menus = agent
    else menus = kang_jia

    this.$store.commit('set_menus', menus)
    if (this.$route.path != '/my/tasks' && this.$route.path != '/') {
      const tabNow = {
        route: this.$route.path,
        name: this.$route.title,
        meta: this.$route.meta,
        query: this.$route.query,
      }
      let flag = false
      this.$store.state.pageTabs.forEach(tab => {
        if (tab.route == tabNow.route) {
          flag = true
        }
      })
      if (!flag) {
        this.$store.commit('set_active_index', this.$route.path)
        this.$store.commit('add_tabs', tabNow)
      }
    }
  },
  methods: {
    // tab切换时，动态的切换路由
    tabClick() {
      let path = this.activeIndex
      if (this.$route.path != path) {
        this.$router.replace({
          path: path,
        })
      }
    },
    tabRemove(targetName) {
      // 首页不可删除
      if (targetName == '/my/tasks') {
        return
      }
      this.$store.commit('delete_tabs', targetName)
      if (this.activeIndex === targetName) {
        // 设置当前激活的路由
        if (this.pageTabs && this.pageTabs.length >= 1) {
          this.$store.commit('set_active_index', this.pageTabs[this.pageTabs.length - 1].route)
          this.$router.replace({
            path: this.activeIndex,
          })
        } else {
          this.$router.replace({
            path: '/my/tasks',
          })
        }
      }
    },
    logout() {
      window.sessionStorage.removeItem('token')
      window.sessionStorage.removeItem('roles')
      window.sessionStorage.removeItem('adminer')
      window.sessionStorage.removeItem('user_type')
      window.sessionStorage.removeItem('company')
      window.sessionStorage.removeItem('type')
      window.sessionStorage.removeItem('code')
      window.sessionStorage.removeItem('username')
      window.sessionStorage.removeItem('userId')
      window.sessionStorage.removeItem('title')
      window.sessionStorage.removeItem('username')
      this.$router.push('/login')
    },
    getLatestChats() {
      this.$util
        .get('kefu/latest', {
          page: this.customerPage,
          keyword: this.kefuSearchKeyword,
        })
        .then(res => {
          if (this.customerPage > 0) {
            this.customers = this.customers.concat(res)
          } else {
            this.customers = res
          }
        })
    },
    catchChat() {
      this.$echo.private('chat_user.1').listen('ChatToUser', payload => {
        console.log(payload)
        let hasCustomer = false
        this.customers.forEach((customer, i) => {
          if (customer.id == payload.member_id) {
            hasCustomer = true
            let msg = {}
            if (payload.is_reply == 1) {
              msg = {
                id: payload.id,
                type: payload.is_reply,
                nickname: payload.nickname,
                avatar: payload.avatar,
                time: payload.time,
                message: payload.content,
              }
            } else {
              msg = {
                id: payload.id,
                type: payload.is_reply,
                nickname: '康灵客服',
                avatar: require('@/assets/doctor.png'),
                time: payload.time,
                message: payload.content,
              }
            }
            if (msg.type == 1) {
              customer.count++
              this.$notify.info({
                title: msg.nickname,
                dangerouslyUseHTMLString: true,
                message: msg.message,
                position: 'bottom-right',
                offset: 100,
              })
              let audio = document.getElementById('kfmp3')
              audio.play()
            }
            customer.messages.push(msg)
            this.customers.splice(i, 1)
            this.customers.unshift(customer)
          }
        })

        if (!hasCustomer) {
          let customer = {
            id: payload.member_id,
            nickname: payload.nickname ? payload.nickname : '游客' + payload.member_id,
            avatar: payload.avatar,
            count: 1,
            current: this.customers.length > 0 ? false : true,
            reply: '',
            messages: [],
          }

          let msg = {}
          if (payload.is_reply == 1) {
            msg = {
              id: payload.id,
              type: payload.is_reply,
              nickname: payload.nickname,
              avatar: payload.avatar,
              time: payload.time,
              message: payload.content,
            }
          } else {
            msg = {
              id: payload.id,
              type: payload.is_reply,
              nickname: '康灵客服',
              avatar: require('@/assets/doctor.png'),
              time: payload.time,
              message: payload.content,
            }
          }
          customer.messages.push(msg)
          this.customers.unshift(customer)
          if (msg.type == 1) {
            this.$notify.info({
              title: msg.nickname,
              dangerouslyUseHTMLString: true,
              message: msg.message,
              position: 'bottom-right',
              offset: 100,
            })
            let audio = document.getElementById('kfmp3')
            audio.play()
          }
        }

        if (this.kefuDialogVisible) {
          this.$nextTick(() => {
            let msgBox = this.$refs.messageScroll
            msgBox.scrollTop = msgBox.scrollHeight
          })
        }
      })
    },
    showKefu() {
      this.kefuDialogVisible = true
      setTimeout(() => {
        this.$nextTick(() => {
          let msgBox = this.$refs.messageScroll
          msgBox.scrollTop = msgBox.scrollHeight
        })
      }, 1000)
    },
    changeTab(i) {
      let customers = this.customers
      for (let i = 0; i < customers.length; i++) {
        customers[i].current = false
      }
      customers[i].current = true
      this.customers = customers
      this.reply = customers[i].reply
      this.$nextTick(() => {
        let msgBox = this.$refs.messageScroll
        msgBox.scrollTop = msgBox.scrollHeight
      })
    },
    sendMsg() {
      if (this.reply == '') {
        this.$message('请输入回复内容')
        return false
      }
      let customers = this.customers
      for (let i = 0; i < customers.length; i++) {
        if (customers[i].current) {
          customers[i].reply = ''
          this.$util
            .post('kefu/reply', {
              content: this.reply,
              member_id: customers[i].id,
              type: 'text',
            })
            .then(() => {
              customers[i].count = 0
            })
        }
      }
      this.reply = ''
      this.customers = customers
    },
    customerReply(event) {
      let customers = this.customers
      for (let i = 0; i < customers.length; i++) {
        if (customers[i].current) {
          customers[i].reply = event.html
        }
      }
    },
    handleFace(img) {
      this.reply += '<img src="' + img + '">'
      let customers = this.customers
      for (let i = 0; i < customers.length; i++) {
        if (customers[i].current) {
          customers[i].reply = this.reply
        }
      }
    },
    customerLoad() {
      this.customerPage++
      this.getLatestChats()
    },
    onKefuSearch() {
      this.customerPage = 0
      this.getLatestChats()
    },
  },
  computed: {
    pageTabs() {
      return this.$store.state.pageTabs
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex
      },
      set(val) {
        this.$store.commit('set_active_index', val)
      },
    },
    permissions() {
      return this.$store.state.permissions
    },
    menus() {
      return this.$store.state.menus
    },
    messages() {
      let customers = this.customers
      let messages = []
      customers.forEach(customer => {
        if (customer.current) {
          messages = customer.messages
        }
      })
      return messages
    },
    newMsgCount() {
      let customers = this.customers
      let sum = 0
      customers.forEach(customer => {
        if (customer.count > 0) {
          sum++
        }
      })
      return sum
    },
  },
  watch: {
    $route(to) {
      let flag = false
      for (let option of this.pageTabs) {
        if (option.route === to.path) {
          flag = true
          this.$store.commit('set_active_index', to.path)
          break
        }
      }
      if (!flag) {
        this.$store.commit('add_tabs', {
          route: to.path,
          name: to.title,
          meta: to.meta,
          query: to.query,
        })
        this.$store.commit('set_active_index', to.path)
      }
    },
  },
}
</script>

<style scoped>
::v-deep .el-submenu__title,
::v-deep .el-menu-item {
  display: flex;
  align-items: center;
}

.mainer {
  height: 100%;
}

.el-header {
  padding: 0;
}

.el-header,
.el-aside {
  background-color: #2f3e62;
}

.page-tabs {
  background-color: #fff;
  padding: 20px 20px 0;
}

.page-tabs /deep/ .el-tabs__header {
  margin-bottom: 0;
}

.brand {
  text-align: center;
  color: #fff;
}

.page-tabs /deep/ .el-tabs__content {
  padding: 0;
}

.el-menu {
  border-right: none;
}

.el-footer {
  background-color: #f6f6f6;
}

.copy-content {
  font-size: 12px;
  line-height: 60px;
  color: #888;
}

.kefu-btn {
  margin-top: 12px;
  margin-right: 15px;
  float: right;
}

.kefu-dialog /deep/ .el-dialog {
  box-shadow: rgba(0, 0, 0, 0.3) 0 0 20px;
  border-radius: 10px;
  overflow: hidden;
}

.kefu-dialog /deep/ .el-dialog__header {
  background-color: #548dca;
}

.kefu-dialog /deep/ .el-dialog__close {
  color: #fff;
}

.kefu-dialog /deep/ .el-dialog__title {
  color: #fff;
}

.kefu-dialog /deep/ .el-dialog__body {
  padding: 0;
}

.el-image {
  vertical-align: middle;
}

.kefu-box {
  display: flex;
  align-items: center;
}

.kefu-customers {
  width: 200px;
  height: 400px;
  border-right: #eee 1px solid;
  overflow-y: scroll;
}

.kefu-customer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
}

.kefu-customer.on {
  background-color: rgb(80, 134, 165);
  color: #fff;
}

.kefu-customer .avatar {
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.kefu-customer .nickname {
  font-size: 14px;
}

.kefu-customer-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.kefu-customer-messages {
  height: 400px;
  width: 600px;
}

.kefu-messages {
  height: 300px;
  width: 600px;
  overflow-y: scroll;
}

.kefu-message {
  padding: 10px 20px;
}

.kefu-reply-box {
  height: 100px;
  width: 600px;
  overflow-y: scroll;
}

.reply-content {
  height: 90%;
  padding: 0 5px;
}

.message-box {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.message-avatar {
  width: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.message-content {
  width: calc(100% - 60px);
}

.message-header {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}

.message-header .nickname {
  margin-right: 20px;
}

.message-header .time {
  color: #999;
  font-size: 12px;
}

.customer-message .content {
  background-color: rgb(192, 182, 87);
  border: rgb(192, 182, 87) 1px solid;
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
}

.replay-message .message-content {
  text-align: right;
}

.replay-message .message-avatar {
  width: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 0;
  margin-left: 10px;
}

.replay-message .message-header {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
}

.replay-message .message-header .nickname {
  margin-right: 0;
  margin-left: 10px;
}

.replay-message .content {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  border: #ddd 1px solid;
  text-align: left;
}

.kefu-tools {
  border-top: #eee 1px solid;
  border-bottom: #eee 1px solid;
}

.tool-btn {
  display: inline-block;
  padding: 5px 10px;
  font-size: 18px;
  cursor: pointer;
  border-right: #eee 1px solid;
}

.kefu-customer-search {
  padding: 5px 10px;
}

.user {
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.usertitle {
  margin-left: 10px;
  color: #ffffff !important;
}

.usertitle p:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #ffffff;
}

.usertitle p:last-child {
  font-size: 12px;
  font-family: Microsoft YaHei;
  color: #ffffff;
  /* margin-top: -10px; */
}

.user span {
  font-weight: bold;
  font-size: 12px;
  color: #ffffff;
  font-family: PingFang SC;
}
</style>
<style>
.customer-message .content img {
  max-width: 100% !important;
}

.customer-message .content p {
  margin: 0 !important;
}
</style>
